import React, { Fragment, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onSortCriteriaChanged } from '../Actions/FacetedSearch.action';

const SortCriteriaCompact = () => {
  const dispatch = useDispatch();
  const facetedSearchState = useSelector((state) => state.facetedSearch);
  const { sortCriteria } = facetedSearchState;
  const getPreSelectedSortItem = useCallback(
    () => sortCriteria?.sortItems?.find((i) => i.selected),
    [sortCriteria]
  );

  const [sortBy, setSortBy] = useState(getPreSelectedSortItem()?.query ?? '');

  const onSortChange = (e) => {
    const query = e.target.value;
    setSortBy(query);
    dispatch(onSortCriteriaChanged(query));
  };

  return (
    <div className="columns">
      <select value={sortBy} className="form__input" onChange={onSortChange}>
        {sortCriteria?.sortItems?.length > 0 &&
          sortCriteria.sortItems.map(({ text, query }, index) => (
            <option value={query} key={`sorteriaCompact-${index}-${query}`}>
              {text}
            </option>
          ))}
      </select>
    </div>
  );
};

export default SortCriteriaCompact;
